
const Trades = () => {
    return (
        <div className="h-[calc(100vh-49px)]">
            <div className="flex flex-col items-center h-full justify-center">
                <h2>Trades</h2>
                <p>Coming soon!</p>
            </div>
        </div>
    )
}

export default Trades